import Plyr from 'plyr';

export default new class Videos {
	init() {
		this.initVideos();
    }

    initVideos() {
    	const videos = document.querySelectorAll('.js-video');

		if (videos.length > 0) {
			const players = Array.from(videos).map((el) => new Plyr(el,{
				youtube: { noCookie: true, showinfo: 0, iv_load_policy: 3 }
			}));
		}
	}
}